export const basePath = window.location.host.includes("localhost") ? "/" : "/";
export const hostname = "//lloydsinn.com/staging/cms";
// export const hostname = "//lloydsinn.com/wp65";


export interface Page {
  name: string;
  slug: string;
}

export const pages: Page[] = [
  { name: "Concept", slug: "concept" },
  { name: "Discover", slug: "discover" },
  { name: "Shop", slug: "shop" },
  { name: "Deals", slug: "deals" },
  { name: "Press", slug: "press" },
  { name: "Contact", slug: "contact" },
];

export const sections: Page[] = [
  { name: "Rest", slug: "rest" },
  { name: "Experience", slug: "experience" },
  { name: "Location", slug: "location" },
  { name: "Events", slug: "events" },
  { name: "FAQ", slug: "faq" },
];

export const locations: string[] = ["Singapore", "Bali", "Kuala Lumpur"];

// Optional: type for MapStyle object
export interface MapStyle {
  featureType: string;
  elementType: string;
  stylers: Array<Record<string, string | number>>;
}

/* eslint-disable */
export const mapStyles: MapStyle[] = [
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      { saturation: 36 },
      { color: "#91989e" },
      { lightness: 40 },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      { visibility: "on" },
      { color: "#ffffff" },
      { lightness: 16 },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      { visibility: "off" },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      { color: "#fefefe" },
      { lightness: 20 },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      { color: "#fefefe" },
      { lightness: 17 },
      { weight: 1.2 },
    ],
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels.text",
    stylers: [
      { visibility: "simplified" },
      { lightness: "55" },
      { color: "#91989e" },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      { color: "#e2e3e4" },
      { lightness: "50" },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      { color: "#f5f5f5" },
      { lightness: 21 },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text",
    stylers: [
      { visibility: "on" },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      { color: "#f5f5f5" },
      { lightness: 21 },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      { color: "#ffffff" },
      { lightness: 17 },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      { color: "#ffffff" },
      { lightness: 29 },
      { weight: 0.2 },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      { color: "#f5f5f5" },
      { lightness: 18 },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      { color: "#ffffff" },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      { color: "#f5f5f5" },
      { lightness: 16 },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [
      { color: "#ffffff" },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      { color: "#f2f2f2" },
      { lightness: 19 },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      { color: "#efefef" },
      { lightness: 17 },
    ],
  },
];
/* eslint-enable */
